import ButtonLink from "tds/buttonLink";

export { ButtonLink };

customElements.define("tds-button-link", ButtonLink.CustomElementConstructor);
